import geo from 'geo-for-http'
import * as env from '@/common/utils/env'
import { getSodaGlobalParams } from '@/common/utils/bridge'
import jsonp from 'jsonp'
import { trackEvent } from '@/common/utils/log'

export function getLocation() {
  return new Promise((resolve, reject) => {
    // 如果能拿到Bridge的定位方法 走客户端定位
    getSodaGlobalParams()
      .then(data => {
        console.warn('走客户端定位', data)
        const { lat, lng } = data

        const regZero = /^(-|\+)?0(.0*)*$/
        // 过滤经纬度为 '0.000000'的情况
        if (regZero.test(lng) || regZero.test(lng) || !lat || !lng) {
          console.warn('客户端定位失败，获取空', data)
          trackEvent('sailing_gattarman_x_action_locate_native_err', {
            errnoInfo: '客户端定位失败，获取空',
            lat,
            lng,
          })
          getH5Location(resolve)
          return
        }
        resolve({
          lat: parseFloat(lat),
          lng: parseFloat(lng),
          hasError: false,
        })
        trackEvent('sailing_gattarman_x_action_locate_native_succ', {
          poi: {
            lat,
            lng,
          },
        })
      })
      .catch(err => {
        console.warn('客户端获取定位失败, 走腾讯H5定位')
        trackEvent('sailing_gattarman_x_action_locate_native_err', {
          errnoInfo: {
            err,
            errtype: 'catch err',
          },
        })
        getH5Location(resolve)
      })
  })
}

export function getH5Location(resolve) {
  const POS_OPTIONS = {
    enableHighAccuracy: false,
    timeout: 5 * 1000,
    maximumAge: 0,
  }

  let getCurrentPosition = null

  if (env.isHttps) {
    getCurrentPosition = geo.getCurrentPosition.bind(null, 'h5', POS_OPTIONS)
  } else {
    getCurrentPosition = function () {
      return new Promise((resolve, reject) => {
        // http://lbs.qq.com/webservice_v1/guide-ip.html
        jsonp(
          'https://apis.map.qq.com/ws/location/v1/ip?key=S2XBZ-EFUHV-ZXNPO-UB7MU-DACB2-5KFTP&output=jsonp',
          null,
          (err, data = {}) => {
            if (err) {
              const errInfo = {
                err,
                ext: {
                  type: 'qqmap',
                  status: data.status,
                },
              }
              reject(errInfo)
            } else if (data.status === 121 || !data.result) {
              const errInfo = {
                err: new Error(data.message),
                ext: {
                  type: 'qqmap',
                  status: data.status,
                },
              }
              reject(errInfo)
            } else {
              resolve({ ...data.result.location, hasError: false, type: 'qqmap' })
            }
          },
        )
      })
    }
  }
  // 先常规请求定位
  getCurrentPosition()
    .then(res => {
      resolve(res)
      trackEvent('sailing_gattarman_x_action_locate_h5_succ', {
        poi: res,
        isHttps: env.isHttps,
      })
    })
    .catch(err => {
      console.error(err)
      trackEvent('sailing_gattarman_x_action_locate_h5_err', {
        errnoInfo: err,
      })
      // 定位失效，默认墨西哥
      const DOWN_GRADE_POS = {
        lat: 19.24,
        lng: -99.09,
      }
      resolve({
        ...DOWN_GRADE_POS,
        hasError: true,
      })
    })
}

const earthRadius = 6378.137 // 地球半径，单位为千米
function rad(d) {
  return (d * Math.PI) / 180.0
}
export function getDistance(lng1, lat1, lng2, lat2) {
  const radLat1 = rad(lat1)
  const radLat2 = rad(lat2)
  const a = radLat1 - radLat2
  const b = rad(lng1) - rad(lng2)
  // 根据 Haversine 公式计算两点之间的距离。该公式使用了正弦和余弦函数，以及平方根来计算距离。
  const s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2),
      ),
    )
  // 将计算得到的距离与地球半径相乘，并将结果保留三位小数。
  const result = parseFloat((s * earthRadius).toFixed(3))
  return result
  // 示例使用
  // const distanceBetweenPoints = getDistance(120.0, 30.0, 121.0, 31.0);
  // console.log(`距离：${distanceBetweenPoints} 千米`);
}
